<template>
  <div style="display: flex;justify-content: space-between">
    <el-checkbox v-model="job.transfering" no="11" style="line-height: 28px;" @change="onChange('transfering')">{{ label }}</el-checkbox>
    <el-button
      :disabled="disabled || !job.transfering"
      :title="$t('SeaExport.EnterTransitInfo')"
      type="primary"
      style="display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;margin-left: 2px;"
      @click="setTransferingHandler"
    >
      {{ $t('SeaExport.EnterTransitInfo') }}
    </el-button>
    <!--输入中转信息-->
    <transit-port-dialog :visible.sync="transitPortDialog.visible" :job="job" @enter="transitPortDialogCallback" />
  </div>
</template>

<script>
import lang from '@/lang'
import TransitPortDialog from '@/views/cargo/v0/AirExport/components/AeBooking/tabs/components/TransitPortDialog'

export default {
  name: 'AeBasicTransfering',
  components: { TransitPortDialog },
  props: {
    job: { type: Object, default: () => { return {} } },
    label: { type: String, default: lang.t('SeaExport.Transit') },
    disabled: { type: Boolean, default: false }
  },
  data() {
    return {
      transitPortDialog: {
        visible: false
      }
    }
  },
  methods: {
    onChange(key) {
      this.$emit('childrenChange', [{ key, value: this.job[key] }])
    },
    setTransferingHandler() {
      this.transitPortDialog.visible = true
    },
    transitPortDialogCallback() {
      const keys = [
        'secondPortCode', 'secondCarrierId', 'secondFlight', 'secondMawb', 'thirdPortCode', 'thirdCarrierId', 'thirdFlight', 'thirdMawb', 'secondEta', 'secondEtd', 'secondAta', 'secondAtd', 'thirdEtd', 'thirdEta', 'thirdAta', 'thirdAtd'
      ]
      const data = []
      keys.forEach(key => {
        data.push({ key, value: this.job[key] })
      })
      this.$emit('childrenChange', data)
    }
  }
}
</script>
